import { LangEn } from 'assets/locales/en';
import { Language } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';
import BadgeSquare from 'components/badge/badgeSquare';
import Tooltip from 'components/tooltips/Tooltips';

// Read from the locale files rather than the Context: the mission card also
// renders outside the provider (its tests, the contract preview modal).
const language = new Language();
language.loadLanguage(LangFr);
language.loadLanguage(LangEn);
language.setLanguage('fr');

const jobbizBackfillText = (key) =>
  language.getValue(`jobbizBackfill.${key}`, '');

// Orange: a colour no mission status badge uses, so the flag never reads as one.
const BADGE_TYPE = 21;

/**
 * Flags a mission whose company turned off "Jobbiz complète si besoin": the
 * admin must not offer it to other profiles nor look for a replacement.
 * Only an explicit `false` counts — a mission without the field backfills.
 */
const JobbizBackfillOffBadge = ({ mission }) => {
  if (mission?.jobbiz_backfill !== false) return null;

  return (
    <Tooltip text={jobbizBackfillText('offTooltip')} placement="top">
      <div data-testid="jobbiz-backfill-off-badge">
        <BadgeSquare
          type={BADGE_TYPE}
          size="12"
          customLabel={jobbizBackfillText('offLabel')}
        />
      </div>
    </Tooltip>
  );
};

export default JobbizBackfillOffBadge;
